<template>
  <div
    :style="{
      height: !isMobile && isTran ? '0px' : isMobile ? '0.5rem' : '60px',
    }"
    class="header-wrapper"
  >
    <div
      :class="{ 'hover-active': fade }"
      :style="{
        background: isTran ? getBgColor() : 'rgb(255, 255, 255, 1)',
      }"
      class="header-pc-wrapper"
      @mouseleave="toggleFade, (isHover = false)"
      @mouseenter.stop="toggleFade, (isHover = true)"
    >
      <!-- :class="{'header-active' : headerFixed, 'hover-active' : fade}" -->
      <div class="header-main-pc">
        <div class="logo-main">
          <router-link class="link-index" to="/">
            <img
              :src="
                $i18n.locale == 'zh_CN'
                  ? '/static/images/logo/logo_v2.png'
                  : '/static/images/logo/logo_v2.png'
              "
              alt=""
              style="width: 140px; height: 40px;margin-top: 10px"
            />
          </router-link>
        </div>
        <div class="header-nav">
          <div
            v-for="(value, index) in $t('header.list')"
            :key="index"
            class="nav-list">
            <div
              v-if="value.children"
              class="nav-parent"
              @mouseenter="toggleSlide(index)"
              @mouseleave="toggleSlide">
              <div :id="value.id" class="parent-item">{{ value.title }}</div>
              <div
                v-if="index === currentIndex"
                v-show="show"
                class="nav-children">
                <div
                  v-for="(item, index) in value.children.list"
                  :key="index"
                  class="children-item">
                  <router-link
                    :to="item.link"
                    class="children-TEXT">
                    <span class="item-text">{{ item.alias }}</span>
                  </router-link>
                </div>
                <!--                产品中心-->
                <div v-if="value.children.list.length<=0"
                     class="cp-center">
                  <div class="cp-box">
                    <div class="cp-box-left">
                      <div class="cp-title">{{ $t('header.text1') }}</div>
                      <div v-for="(i, p) in $t('header.cpList')" :key="p">
                        <div class="cp-name">{{ i.title }}</div>
                        <div class="cp-item">
                          <div v-for="(i2, p2) in i.list"
                               :key="p2"
                               class="cp-text">
                            <router-link :to="i2.router"><div class="cp-text">{{ i2.name }}</div></router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="background: #D8D8D8;width: 1px;margin-left: 110px;margin-top: 30px"></div>
                    <div class="cp-box-right">
                      <div class="top">
                        <div class="cp-right-item" v-for="(i, k) in $t('header.routerList1')" :key="k">
                          <div class="cp-title">{{ i.title }}</div>
                          <div class="cp-right-text-box">
                            <div class="cp-right-text" v-for="(i2, k2) in i.list" :key="k2">
                              <router-link :to="i2.router">
                                <div class="cp-text">{{i2.name}}</div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="background: #E4E4E4;height: 1px;width: 100%"></div>
                      <div class="bottom">
                        <div class="cp-right-item" v-for="(i, k) in $t('header.routerList2')" :key="k">
                          <div class="cp-title">{{ i.title }}</div>
                          <div class="cp-right-text-box">
                            <div class="cp-right-text" v-for="(i2, k2) in i.list" :key="k2">
                              <router-link :to="i2.router">
                                <div class="cp-text">{{i2.name}}</div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="nav-parent">
              <router-link
                v-if="value.target === 'self'"
                :to="value.link"
                class="parent-link">{{ value.title }}
              </router-link>
              <a v-else :href="value.link" target="_blank">{{ value.title }}</a>
            </div>
          </div>
          <!-- <div style="">中文</div> -->
        </div>

        <div class="i18n-main" style="cursor: auto">
<!--          <router-link to="/contactUs">-->
<!--            <div class="contact_bt">-->
<!--              {{ $t("contactNew.text1") }}-->
<!--            </div>-->
<!--          </router-link-->
<!--          >-->
          <span class="i18n-btn" >
             <span  style="color: #999;height: 100%;cursor: pointer" @click="changeLang">
                {{ langName }}
              </span>
            <!-- 中/EN -->
<!--            <el-dropdown trigger="hover" @command="handleCommand">-->
<!--              <span  style="color: #999;height: 100%;cursor: pointer">-->
<!--                {{ langName }}-->
<!--              </span>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item-->
<!--                  :command="item.locale"-->
<!--                  v-for="(item, index) in langs"-->
<!--                  :key="index"-->
<!--                  >{{ item.title }}</el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
          </span>
        </div>
      </div>
    </div>

    <div class="header-m-wrapper">
      <div
        :class="{ 'header-open': headerOpen, 'header-active': headerFixed }"
        class="header-main-mobile"
      >
        <div class="icon-main-wrapper">
          <v-mtoc
            :header-fixed="headerFixed"
            :header-open="headerOpen"
            class="menu-main"
            @openMenu="openMenu"
          ></v-mtoc>
          <div class="logo-main">
            <router-link class="link-index" to="/">
              <img
                v-if="headerFixed || headerOpen"
                alt=""
                src="/static/images/logo/logo.png"
              />
              <img v-else alt="" src="/static/images/logo/logo_base.png"/>
              <!-- <img src="/static/images/logo/logo.png"
                   alt="航翊科技"> -->
            </router-link>
          </div>
        </div>
        <div
          :class="[headerOpen ? 'nav-wrapper-visible' : '']"
          class="nav-main-wrapper"
        >
          <div
            :class="[secondMenuOpen ? 'transformLeft' : 'transformRight']"
            class="nav-main"
          >
            <div
              v-for="(item, index) in $t('header.listM')"
              :key="index"
              class="nav-list">
              <div
                v-if="item.children"
                v-show="$i18n.locale === 'zh_CN' || item.id != 7"
                class="nav-parent"
                @click.stop="showSecondMenu(index)">
                <div class="parent-item">{{ item.title }}</div>
                <span class="arrow-right"></span>
                <div v-if="index === currentIndex" class="nav-children"  style="height:calc(100vh - 50px);overflow-y: auto">
                  <div class="return-last" @click.stop="hideSecondMenu()">
                    return
                  </div>
                  <div
                    v-for="(item, index) in item.children.list"
                    :key="index"
                    class="children-item"
                    @click.stop="closeHeader"
                  >
                    <router-link
                      v-if="
                        item.state === 'ICON' ||
                        item.state === 'IMG' ||
                        item.state === 'TEXT'
                      "
                      :to="item.link"
                      class="children-link"
                    >{{ item.alias }}
                    </router-link
                    >
                    <div
                      v-if="item.state === 'OTHER'"
                      class="children-link"
                      @click="handleCommand(item.discription)"
                    >
                      {{ item.alias }}
                    </div>
                    <div v-if="item.state === 'SORT'" class="children-SORT">
                      <router-link
                        v-for="(item, index) in item.list"
                        :key="index"
                        :to="item.link"
                        class="children-link"
                      >{{ item.alias }}
                      </router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="nav-parent" @click.stop="closeHeader">
                <router-link :to="item.link" class="parent-link">{{
                    item.title
                  }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 导航调试
// show: true, // 显示二级导航
// currentIndex: 1, // 显示当前item

import mtoc from "@/components/menuToClose/mtoc.vue";

export default {
  props: {
    headerFixed: {
      type: Boolean,
      default: false,
    },
    isTran: {
      //是否背景透明
      type: Boolean,
      default: false,
    },
    tranNum: {
      type: Number,
      default: 0,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: [], // 头部导航数据
      fade: false, // 划过导航是否fade
      show: false, // 是否显示二级导航
      currentIndex: null, // 二级导航显示当前item
      headerOpen: false, // -m 点击menu导航打开
      secondMenuOpen: false, // -m 二级导航打开
      langName: "",
      lang: false, //是否英文
      isHover: false,
      topOption: {
        name: 'HW-600H',
        text: '',
        url: '/static/images/header/header_500h.png'
      },
      langs: [
        {title: "中文", locale: "zh_CN"},
        {title: "English", locale: "en_US"},
      ],
      baseImg:
        "data:image/png;base64,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",
      hoverNum: -1,

    };
  },
  mounted() {
    this.langName = this.$i18n.locale === "en_US" ? "中文" : "English";
    this.topOption.text = this.$i18n.locale === "en_US" ? "Vertical helicopter, heavy load, long endurance, suitable for all scenarios" : "纵列式直升机，大载重，长航时，全场景适用";
  },
  methods: {
    hoverOver(index) {
      this.hoverNum = index;
    },
    getBgColor() {
      if (this.isHover) {
        return 'rgb(255, 255, 255, ' + 1 + ')';
      } else {
        return 'rgb(255, 255, 255, ' + this.tranNum + ')';
      }

    },
    toggleFade() {
      this.fade = !this.fade;
    },
    toggleSlide(index) {
      this.show = !this.show;
      this.currentIndex = index;
    },
    // 移动端方法
    openMenu(status) {
      this.headerOpen = status;
      if (!this.headerOpen) this.secondMenuOpen = false;
    },
    showSecondMenu(index) {
      this.currentIndex = index;
      this.secondMenuOpen = true;
    },
    hideSecondMenu() {
      this.secondMenuOpen = false;
    },
    closeHeader() {
      this.headerOpen = this.secondMenuOpen = false;
    },
    handleCommand(command) {
      this.$i18n.locale = command;
      localStorage.setItem("LANG", command);
      this.langName = this.$i18n.locale === "en_US" ? "中文" : "English";
      location.reload();
    },
    changeLang() {
      if (this.$i18n.locale === "zh_CN") {
        this.$i18n.locale = "en_US";
        localStorage.setItem("LANG", "en_US");
      } else {
        this.$i18n.locale = "zh_CN";
        localStorage.setItem("LANG", "zh_CN");
      }
      location.reload();
    },
    overChangeTop(item) {
      this.topOption.name = item.name;
      this.topOption.text = item.discription;
      this.topOption.url = item.img;
    },
  },
  components: {
    "v-mtoc": mtoc,
  },
};
</script>

<style lang="stylus" scoped>
@media screen and (min-width: 769px) {
  //new
  .cp-center {
    background: #F4F4F4;
    width: 100%;
    display: flex;
    justify-content: center;

    .cp-box {
      width: 1280px;
      display: flex;
      color: #3D3D3D;
      line-height: normal;
      text-align: left;
      margin-bottom: 80px
    }

    .cp-box-left {
      width: 250px;
      margin-left: 48px;
      margin-top: 59px
    }

    .cp-title {
      font-size: 22px;
      font-weight: 800;
    }

    .cp-name {
      margin: 23px 0 15px 44px;
      font-weight: 700
    }

    .cp-item {
      border-left: 1px;
      background: #ECECEC;
      width: 2px;
      margin-left: 50px
    }

    .cp-text {
      margin: 10px 0 5px 18px;
      width: 178px;
      font-size: 16px;
      font-weight: normal;
      &:hover {
        font-weight: bold;
        color: #1F65FE;
      }
    }
    .cp-box-right{
      margin-top: 59px;
      flex: 1;
      margin-left: 22px;
      .top{
        display: flex;
        height: 50%;
      }
      .bottom{
        margin-top: 60px;
        display: flex;
      }
      .cp-right-item{
        margin-left: 50px;
        flex: 1;
      }
      .cp-right-text-box{
        margin-left: 44px;
        margin-top: 18px;
      }
      .cp-right-text{
        margin-bottom: 13px;
      }
    }
  }


  .header-wrapper {
    min-width: 1200px;
    margin: 0 auto;
    height: 0px;

    .header-pc-wrapper {
      width: 100%;
      height: 60px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
      font-size: 16px;
      color: #000000;
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
      background-color: rgba(52, 99, 159, 0);
      box-sizing: border-box;
      transition: all 0.1s ease-in-out;

      &.header-active {
        position: fixed;
        background: #fff;
      }

      &.hover-active {
        transition: all 0.1s ease-in-out;
        background: rgba(255, 255, 255, 1);
      }

      .top-preview-box {
        margin: 90px 0px 90px 0px;
        width: 639px;
        height: 300px;
        display: flex;

        .preview-line {
          height: 300px;
          width: 1px;
          color: rgba(255, 255, 255, 0);
          background-color: rgba(255, 255, 255, 0.2);
        }

        .top-preview {
          margin-left: 44px;
          width: 595px;
          height: 100%;

          .img-preview {
            z-index: 1;
            position: absolute;
            margin-top: -42px;
            margin-left: -155px;
            width: 364px;
            object-fit: fill;
          }

          .img-preview-back {
            z-index: 0;
            position: absolute;
            top: 142px;
            width: 595px;
            height: 150px;
            opacity: 1;
            background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.59) 100%);
          }

          .preview-text-box {
            margin-top: 215px;
            text-align: left;

            .preview-text1 {
              font-size: 24px;
              font-weight: 500;
              line-height: 29px;
              color: #000000;
            }

            .preview-text2 {
              font-size: 16px;
              font-weight: 350;
              line-height: 29px;
              color: #000000;
              margin-top: 3px;
              opacity: 0.8;
              width: 595px;
            }
          }
        }
      }

      .header-main-pc {
        max-width: 1280px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        box-sizing: border-box;

        .logo-main {
          .link-index {
            display: inline-block;
            height: 36px;
            padding: 0px 0;
            text-align: center;
          }
        }

        .header-nav {
          flex: 1;
          width: 100%;
          height: 100%;
          padding-right: 100px;
          display: flex;
          justify-content: flex-end;

          .parent-item {
            font-weight: 800;
            font-size: 16px;
          }

          .nav-list {
            display: inline-block;
            min-width: 110px;
            padding: 0 10px;
            text-align: center;

            &:hover {
              color: #1F65FE;
            }

            &:nth-last-child(1), &:nth-last-child(2), &:nth-last-child(5) {
              .nav-parent {
                position: relative;

                .nav-children {
                  border-radius: 6px;
                  background: #F4F4F4;
                  width: 182px;
                  left: 50%;
                  margin-left: -72px;
                  border: none;
                  flex-direction: column;

                  .children-item {
                    font-weight: 800;
                    width: 100%;
                    line-height: 60px;
                    color: #000000;

                    &:hover {
                    }

                    a {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
              }
            }

            .nav-parent {
              text-align: center;
              line-height: 60px;
              cursor: pointer;

              a:hover {
                color: #000;
              }

              .nav-children {
                position: absolute;
                left: 0;
                top: 60px;
                z-index: 999;
                width: 100%;
                background: rgba(255, 255, 255, 0);
                border-top: 1px solid #B4C3D9;
                border-bottom: 1px solid #B4C3D9;
                box-shadow: 0 20px 40px 0 rgba(138, 158, 189, 0.3);
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: top;

                .children-item {
                  .children-ICON {
                    display: inline-block;
                    min-width: 100px;
                    height: 190px;
                    margin: 5px;
                    border-radius: 4px;

                    &:hover {
                      color: #1F65FE;

                      .item-text {
                        font-weight: 800;
                        color: #1F65FE;
                      }
                    }

                    .item-icon {
                      width: 36px;
                      height: 36px;
                      margin-top: 63px;
                    }

                    .item-text {
                      font-weight: 800;
                      display: block;
                      width: 100%;
                      line-height: 0;
                      color: #000;
                      text-align: center;
                    }
                  }

                  .children-SORT {
                    padding: 0 0.2rem;
                    box-sizing: border-box;
                    text-align: left;
                    vertical-align: top;

                    .item-type {
                      margin-top: 20px;
                      font-size: 14px;
                      font-weight: 350;
                      line-height: 29px;
                      color: rgba(255, 255, 255, 0.6);
                    }

                    .item-type-line {
                      width: 50px;
                      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
                      margin-bottom: 10px;
                    }

                    .item-sort {
                      // width: 480px;
                      width: 320px;

                      .item-title-main {
                        height: 26px;
                        line-height: 26px;
                        margin-top: 30px;
                        margin-bottom: 10px;
                        position: relative;

                        .item-title {
                          font-size: 22px;
                          font-weight: 900;
                          color: #000;
                          position: absolute;
                          left: 0;
                          top: 0;
                          z-index: 1000;
                        }
                      }

                      .item-main {
                        float: left;
                        vertical-align: top;

                        .item-title {
                          height: 20px;
                          font-size: 14px;
                          font-weight: 600;
                          color: #777777;
                          line-height: 20px;
                          margin-bottom: 10px;
                        }

                        .item-content {
                          text-align: left;

                          .item-route {
                            display: block;
                            width: 280px;
                            height: 46px;
                            color: #000;
                            font-weight: 900;
                            line-height: 46px;
                            border-radius: 4px;

                            &:hover {
                              color: #1F65FE;
                            }

                            .route-text {
                              line-height: 46px;
                              font-size: 22px;
                              vertical-align: top;
                            }
                          }
                        }
                      }

                      .clear {
                        clear: both;
                      }
                    }
                  }

                  .children-IMG {
                    display: inline-block;
                    width: 250px;
                    height: 140px;
                    margin: 40px 5px;
                    border-radius: 4px;
                    background: #FDFDFE;

                    &:hover {
                      background: #F5F7FA;
                    }

                    .item-text {
                      line-height: 40px;
                      color: #000;
                      vertical-align: top;
                    }
                  }

                  .children-TEXT {
                    font-weight: 800;
                    color: #000;

                    &:hover {
                      font-weight: 800;
                      color: #1F65FE;
                    }
                  }
                }
              }

              .parent-link {
                display: inline-block;
                width: 100%;
                height: 100%;
                font-weight: 800;
                color: #000;

                &:hover {
                  color: #1F65FE !important;
                }
              }
            }
          }
        }

        .contact_bt {
          margin-right: 18px;
          line-height: 40px;
          font-size: 16px;
          color: white;
          border-radius: 1px;
          width: 100px;
          height: 42px;
          border: 2px solid rgba(255, 255, 255, 0.4);
        }

        .i18n-main {
          justify-content: flex-end;
          display: flex;
          align-items: center;
          height: 100%;
          right: 20px;
          top: 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;

          .i18n-btn {
            font-size: 14px;
            font-weight: 800;
            line-height: 36px;
          }
        }
      }
    }

    .header-m-wrapper {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .header-wrapper {
    height: 0.5rem;

    .header-m-wrapper {
      width: 100%;
      height: auto;
      font-size: 0.16rem;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999999;

      .header-main-mobile {
        // height: 0.68rem;
        height: 0.5rem;
        position: relative;
        background: rgba(0, 0, 0, 1);
        border-bottom: 1px solid rgba(0, 0, 0, 1);
        transition: all 0.5s ease-in-out;

        &.header-open {
          border-bottom: 1px solid #f2f2f2;
          transition: all 0.5s ease-in-out;
          background: rgba(255, 255, 255, 1);
        }

        &.header-active {
          height: 0.5rem;
          border-bottom: 1px solid #f2f2f2;
          background: rgba(255, 255, 255, 1);
          transition: all 0.5s ease-in-out;
        }

        .icon-main-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 0.5rem;
          z-index: 999;

          .menu-main {
            width: 0.22rem;
            height: 0.24rem;
            padding: 0.12rem 0 0 0.12rem;
          }

          .logo-main {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 138px;
            height: 36px;

            .link-index {
              display: inline-block;
              width: 100%;
              height: 100%;
              text-align: center;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .nav-main-wrapper {
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 0.5rem;
          overflow: hidden;
          background: #fff;
          opacity: 0;
          z-index: 400;
          transition: all 0.3s ease-in-out;

          &.nav-wrapper-visible {
            top: 0.5rem;
            height: 100%;
            opacity: 1;
            transition: all 0.5s ease-in-out;
          }

          .nav-main {
            height: auto;
            transform: translate3d(0, 0, 0);

            &.transformLeft {
              transform: translate3d(-100%, 0, 0);
              transition: all 0.5s ease-in-out;
            }

            &.transformRight {
              transform: translate3d(0, 0, 0);
              transition: all 0.5s ease-in-out;
            }

            .nav-parent {
              position: relative;
              padding: 23px 20px 22px;
              border-bottom: 1px solid #f2f2f2;

              .nav-children {
                width: 100%;
                position: fixed;
                left: 100%;
                top: 0;
                background: #fff;

                .return-last {
                  display: block;
                  padding: 18px 20px 17px;
                  border-bottom: 1px solid #f2f2f2;
                  background: #F5F7FA;
                }

                .children-item {
                  .children-SORT {
                    .children-link {
                      display: block;
                      padding: 23px 20px 22px;
                      border-bottom: 1px solid #f2f2f2;
                    }
                  }

                  .children-link {
                    display: block;
                    padding: 23px 20px 22px;
                    border-bottom: 1px solid #f2f2f2;
                  }
                }
              }

              .arrow-right {
                position: absolute;
                right: 0.2rem;
                top: 50%;
                margin-top: -11px;

                &:before {
                  content: '>';
                  display: block;
                  height: 22px;
                  width: 22px;
                  text-align: center;
                  line-height: 22px;
                }
              }

              .parent-link {
                display: block;
              }
            }
          }
        }
      }
    }

    .header-pc-wrapper {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header_v2.vue